import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, shipmentStatuses, Text } from '@reveni-io/reveni-ui'

import CarrierSelector from '@/common/components/CarrierSelector/CarrierSelector'

import * as Styles from './styles'

const EditCarrierServiceModal = ({
  show,
  carrierServiceSelected,
  carrierServices,
  editingCarrierService,
  onClose,
  onEditCarrierServices,
  loadingCarrierServices,
  parcelStatus,
}) => {
  const { t } = useTranslation()
  const [newCarrierService, setNewCarrierService] = useState(carrierServiceSelected)

  const handleOnEditOrigin = () => {
    onEditCarrierServices(newCarrierService)
    onClose()
  }

  return (
    <Modal title={t('Editar servicio de logística')} show={show} size="l" onClose={onClose}>
      <Styles.MainContainer>
        <Text type="bodyMRegular">{t('Elige el servicio de logística que se utilizará para el envío')}:</Text>
        <CarrierSelector
          value={newCarrierService}
          onChange={carrierService => setNewCarrierService(carrierService?.id)}
          carriers={carrierServices}
        />
        {parcelStatus === shipmentStatuses.ready && (
          <Alert type="warning">
            {t(
              'Al editar el servicio de logística se creará una nueva etiqueta de envío (y la documentación asociada) que sustituirá a la generada anteriormente.'
            )}
          </Alert>
        )}
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Guardar')}
            loadingLabel={t('Guardar')}
            disabled={editingCarrierService || loadingCarrierServices}
            onClick={handleOnEditOrigin}
          />
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Modal>
  )
}

export default EditCarrierServiceModal
